// extracted by mini-css-extract-plugin
export default {"defaultCell":"LightTextRenderer_defaultCell__nAI-t","lightText":"LightTextRenderer_lightText__T1woT"};